// eslint-disable-next-line no-restricted-imports
import InlineLink from 'plaid-threads/InlineLink';
import React from 'react';

import styles from './index.module.scss';

interface Props {
  imageAlt: string;
  imageSrc: string;
  name: string;
  description: string;
  link: string;
}

const Bio: React.FC<Props> = ({
  imageSrc,
  imageAlt,
  name,
  description,
  link,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <img src={imageSrc} alt={imageAlt} />
      </div>
      <div className={styles.details}>
        <h5>{name}</h5>
        <p className={styles.subtitle}>
          {description} <InlineLink href={link}>Learn more</InlineLink>
        </p>
      </div>
    </div>
  );
};

Bio.displayName = 'Bio';
export default Bio;
